import { SignalsAPI } from 'BackEnd/API';
import {
  AcuitySignalsToPlatformAsset,
  INDEXES_DENY_LIST,
} from 'common/constants/signals.constants';
import { DISONA_CURRENCY_ICONS } from 'themes/disonaTheme/icons-disona.constants';
import SignalsStore from '../stores/signals.store';

class SignalsService {
  initSignals = async () => {
    const assetsList = await SignalsAPI.fetchAssetTypes();
    SignalsStore.setAssetsList(assetsList);

    const IDsArray = this.filterAssetsID(assetsList);
    SignalsStore.setforexIDs(IDsArray);
    const arrayFetchUsers = IDsArray.map((item) =>
      SignalsAPI.fetchAssets(item)
    );

    const response = await Promise.all(arrayFetchUsers);
    const flatResponse = response.flat();

    const allAssetsName = this.filterAssetsName(flatResponse);

    SignalsStore.setTickers(allAssetsName);
  };

  filterAssetsName = (assets) => assets.map((item) => item.AssetName);

  filterAssetsID = (assets) => assets.map((item) => item.Id);

  forexEvents = async () => {
    const tradingPair = SignalsStore.tickers;
    const date = new Date();

    const endDate = date.toISOString();

    date.setDate(date.getDate() - 30);
    const startDate = date.toISOString();

    const forexEvents = await SignalsAPI.signalsFXEvents(
      tradingPair,
      endDate,
      startDate
    );
    SignalsStore.setForexEvents(forexEvents);
  };

  signalsData = async () => {
    const forexAssetsIDs = SignalsStore.forexIDs;

    const date = new Date();
    const endDate = date.toISOString();
    date.setDate(date.getDate() - 30);
    const startDate = date.toISOString();

    const dataForSignals = forexAssetsIDs.map((item) =>
      SignalsAPI.fetchSignalsData(item, endDate, startDate)
    );

    const response = await Promise.all(dataForSignals);
    const flatResponse = response.flat();

    const filterSignals = this.filterObjFunc(flatResponse);
    const transformItems = this.transformSignalObject(filterSignals);

    SignalsStore.setAssetsNews(transformItems);
  };

  filterObjFunc = (assets) => {
    const filteredObj = [];
    for (let i = 0; i < assets.length; i++) {
      const item = assets[i];

      const equalDate1 = new Date();
      const equalDate2 = new Date(item.Report.expiry);

      equalDate2.setDate(equalDate2.getDate() + 4);

      if (equalDate1.getTime() <= equalDate2.getTime()) {
        filteredObj.push(item);
      }
    }
    return filteredObj;
  };

  transformSignalObject = (news) => {
    return news.map((item) => {
      const { name } = item.Product;
      const foundPlatformAssetName = AcuitySignalsToPlatformAsset[name];

      if (foundPlatformAssetName) {
        // eslint-disable-next-line no-param-reassign
        item.Product.name = foundPlatformAssetName;
      }

      const denyToAddSlash = INDEXES_DENY_LIST.some(
        (elem) => item.Product.name === elem
      );

      let assetsWithSlash = '';
      if (denyToAddSlash) {
        assetsWithSlash = item.Product.name;
      } else {
        assetsWithSlash = `${item.Product.name.slice(
          0,
          3
        )} / ${item.Product.name.slice(3)}`;
      }
      // eslint-disable-next-line no-param-reassign
      item.beautyUI = assetsWithSlash;

      const foundCoin = DISONA_CURRENCY_ICONS.find(({ label }) =>
        item.Product.name.includes(label)
      );

      // eslint-disable-next-line no-param-reassign
      item.imageUrl = foundCoin?.src;
      // eslint-disable-next-line no-param-reassign
      item.imageUrlLabel = foundCoin?.label;

      return item;
    });
  };
}

export const signalsService = new SignalsService();
